import React from 'react';
import i18n from '../../i18n/i18n';
import { Button, TextField, Grid, IconButton, Dialog, DialogContent, DialogTitle, Typography, Checkbox, DialogContentText } from '@material-ui/core';
import { wentRight, wentWrong } from "../../utils/ToastConfig";
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import axios from '../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';

export default class NewSeasonAlert extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    };

    getUser() {
        let user = localStorage.getItem('user');
        let userObject = JSON.parse(user);
        !user && window.location.replace(window.location.origin);
        return userObject;
    }

    render() {
        let user = this.getUser();
        let link = '';

        if (user.id_region === 2) {
            link = "https://manuals.agrolife.world/farmer/basic/settings/settings_rs";
        }
        else if (user.id_region === 20) {
            link = "https://manuals.agrolife.world/farmer/basic/settings/settings_rs";
        }
        else if (user.id_region === 21) {
            link = "https://manuals.agrolife.world/farmer/basic/settings/settings_rs";
        }
        else if (user.id_region === 23) {
            link = "https://manuals.agrolife.world/farmer/basic/settings/settings_rs";
        }

        else if (user.id_region === 13) {
            link = "https://manuals.agrolife.world/farmer/basic/settings/settings";
        }
        else if (user.id_region === 25) {
            link = "https://manuals.agrolife.world/farmer/basic/settings/settings";
        }
        else if (user.id_region === 26) {
            link = "https://manuals.agrolife.world/farmer/basic/settings/settings";
        }

        return (
            <div style={{ padding: 20 }}>
                <Dialog open={this.props.alert}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title">
                    <DialogTitle disableTypography={true} style={{ background: '#04764e' }} className="responsive-dialog-title">
                        {i18n.t('Consent to the Terms of Use')}
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            <div style={{ padding: '18px 0 0 0', fontFamily: 'Roboto', fontSize: '18px', lineHeight: '26px', textAlign: 'justify' }}>
                                {i18n.t('Welcome to the application for digital farm management and agricultural production tracking.')}
                                <br />
                                <br />
                                {i18n.t('By registering for and using this application, I confirm that I am familiar with the Terms of Use, that I have read, understood, and fully accepted them.')}
                                <br />
                                <br />
                                {i18n.t(`I agree to enter, manage, and regularly update data related to my agricultural production in digital form through this application. Such data may include, but is not limited to, information on agricultural plots, crops and cultivated plants, completed and planned farming activities, input usage, yields, weather conditions, as well as other relevant data important for monitoring and improving agricultural production.`)}
                                <br />
                                <br />
                                {i18n.t('I understand that the purpose of this application is to facilitate the planning, organization, and monitoring of agricultural activities, as well as to improve the efficiency, transparency, and overall quality of agricultural production. I accept that the entered data may be used for production analysis, generation of summaries and reports, and for the development and improvement of digital solutions and services provided by the application.')}
                                <br />
                                <br />
                                {i18n.t('I also understand and accept that certain data, in accordance with applicable laws and regulations, may be made available to competent local authorities, institutions, and other authorized bodies, exclusively for official, statistical, planning, and development purposes. Such data will not be used for other purposes without my knowledge and access, except where required by law.')}
                                <br />
                                <br />
                                {i18n.t('I confirm that all data I enter is accurate, truthful, and up to date, and I accept responsibility for its accuracy. I agree that my data may be processed, stored, and used in a secure manner, in accordance with personal data protection regulations and the applicable legislation of Bosnia and Herzegovina.')}
                                <br />
                                <br />
                                {i18n.t('The user has the right at any time to access their data, request corrections, updates, or deletion of their data, in accordance with applicable laws and the technical capabilities of the system. I also have the right to receive information regarding how my data is processed and used.')}
                                <br />
                                <br />
                                {i18n.t('The service provider reserves the right to amend or update the Terms of Use for the purpose of improving application functionality or ensuring compliance with legal requirements. Users will be timely informed of any significant changes through the application or by other appropriate means.')}
                                <br />
                                <br />
                                {i18n.t('By using this application, I acknowledge that it serves as a support tool for agricultural production and does not replace professional advice from competent institutions, advisory services, or certified agronomy experts.')}
                                <br />
                                <br />
                                {i18n.t('By clicking the “I Agree” button, I confirm that I have voluntarily given my consent, that I am aware of my rights and obligations, and that I accept all of the above Terms of Use.')}

                                <br /><br />
                                {/* <a href={link} target="_blank" style={{ color: 'blue', textDecoration: 'underline' }}>
                                    {i18n.t('Guide on how to change the season')}
                                </a>
                                <br /> <br />
                                {i18n.t('For additional questions, you can contact us by e-mail or phone')}: <br />
                                {i18n.t('E-mail adresa')}: agrolife.podrska@gmail.com<br />
                                {i18n.t('Phone')}: 021 / 271 - 4500 <br /> */}
                            </div>
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <Button variant='contained' color='secondary' onClick={() => {
                                    axios.post('api/status/privacy_policy_update');
                                    this.props.handleClose();
                                }}>{i18n.t('I Agree')}</Button>
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            </div >
        );
    };
};